(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        root.Qd.FormsViewer.UI.uiLoaderShared = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {
    var $ = jQuery;

    var errorPanelCheckInterval = 100;

    var notificationInterval;

    function setErrorPanelZindex() {
        var panel = $('div[id^=SP_RequestExecutor_NotificationPanel]');

        if (!panel.length) {
            return;
        }

        var panelIndex = panel.css('z-index');
        var loaderIndex = parseInt($('div#divLoader').css('z-index'));

        if (panelIndex && panelIndex !== 'auto') {
            clearInterval(notificationInterval);
            notificationInterval = null;
            return;
        }

        panel.css('z-index', loaderIndex + 1);
        clearInterval(notificationInterval);
        notificationInterval = null;
    }

    function setLoaderText(text) {
        $('div#divContent').text(text);
    }

    function displayOverlay() {
        notificationInterval = setInterval(setErrorPanelZindex, errorPanelCheckInterval);
        showingLoader = true;

        $('#divLoaderContainer').removeClass('hidden');
    }

    function hideOverlay() {
        showingLoader = false;

        $('#divLoaderContainer').addClass('hidden');
        $('div#divContent').html('');

        if (notificationInterval) {
            clearInterval(notificationInterval);
        }
    }

    return {
        displayOverlay: displayOverlay,
        hideOverlay: hideOverlay,
        setLoaderText: setLoaderText,
    };
}));

